;(function() {
  'use strict'

  angular.module('core.filters').filter('emailToA', emailToA)

  function emailToA() {
    return function(string, noClick) {
      // copied from email.service.js and modified
      var EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi

      return string ? string.replace(EMAIL_REGEX, replace) : string

      function replace(email) {
        if (noClick) {
          return '<a>' + email + '</a>'
        } else {
          return '<a href="mailto:' + email + '">' + email + '</a>'
        }
      }
    }
  }
})()
